export default __webpack_public_path__ + "static/2-c8b7c6103da1b4aed2b56a9c7cc2c836.jpg";